/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {GestioneUtentiWidget} from '../../../_metronic/partials/widgets/customs/GestioneUtentiWidget'

export function GestioneUtenti() {
  return (
    <>	
      <div className='col-xl-12'>
        <GestioneUtentiWidget className='card-xxl-stretch mb-5 mb-xl-10' />
      </div>
    </>
  )
}
